import type { ComponentType } from "react";

import type { OrderedSearchFilterInstance, SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import AppsAndroidFilterIcon from "../components/AppsFilterIcon/AppsAndroidFilterIcon";
import AppsIosFilterIcon from "../components/AppsFilterIcon/AppsIosFilterIcon";
import { AppsFeatureUpgradeView } from "../components/upgrade-views/AppsFeatureUpgradeView";
import type { AppOperatingSystem } from "../types/commonFiltersDto";

const platformIconMap: Record<AppOperatingSystem, ComponentType> = {
    android: AppsAndroidFilterIcon,
    ios: AppsIosFilterIcon,
};

export const withFilterBaseProps =
    (platform: AppOperatingSystem) =>
    (filter: SearchFilterInstance, order: number): OrderedSearchFilterInstance => {
        filter.icon = platformIconMap[platform];

        filter.order = order;

        if (!salesSettingsHelper.isConsolidatedAppsEnabled && filter.filterView) {
            filter.gateStatus = { type: "upgrade", view: AppsFeatureUpgradeView };
        }

        return filter as OrderedSearchFilterInstance;
    };
